module.exports = __webpack_public_path__ + "img/Yarn_trading.6368f9fe.png";